<template>
	<div>
		<el-popover trigger="hover" placement="left">
			<div>
				<div v-if="canEdit" class="menu-item" @click="handleFunc('edit')">
					<i class="el-icon-edit" style="margin-right: 5px" />
					<span>{{ $t("edit") }}</span>
				</div>

				<div v-if="canBlock" class="menu-item" @click="handleFunc('block', false)">
					<i class="el-icon-lock" style="margin-right: 5px" />
					<span>{{ $t("block") }}</span>
				</div>

				<div v-if="canUnblock" class="menu-item" @click="handleFunc('block', true)">
					<i class="el-icon-unlock" style="margin-right: 5px" />
					<span>{{ $t("unblock") }}</span>
				</div>

				<div v-if="canRestore" class="menu-item" @click="handleFunc('restore', true)">
					<i class="el-icon-refresh-left" style="margin-right: 5px" />
					<span>{{ $t("restore") }}</span>
				</div>

				<div v-if="canReport" class="menu-item" @click="handleFunc('report')">
					<i class="el-icon-warning" style="margin-right: 5px" />
					<span>{{ $t("report") }}</span>
				</div>

				<div v-if="canDelete" class="menu-item" @click="handleFunc('delete')">
					<i class="el-icon-delete" style="margin-right: 5px" />
					<span>{{ $t("delete") }}</span>
				</div>
				<div v-if="canConfirm" class="menu-item" @click="handleFunc('confirm')">
					<i class="el-icon-postcard" style="margin-right: 5px" />
					<span>{{ $t("confirm-email") }}</span>
				</div>
			</div>

			<div slot="reference">
				<md-button class="md-icon-button" @click="e => e.stopPropagation()">
					<md-icon>more_vert</md-icon>
				</md-button>
			</div>
		</el-popover>
	</div>
</template>

<script>
export default {
	name: "option-table-button",
	props: ["buttons", "placement", "item"],
	computed: {
		canEdit: function () {
			return this.buttons.indexOf("edit") > -1
		},
		canBlock: function () {
			return this.buttons.indexOf("block") > -1
		},
		canUnblock: function () {
			return this.buttons.indexOf("unblock") > -1
		},
		canDelete: function () {
			return this.buttons.indexOf("delete") > -1
		},
		canRestore: function () {
			return this.buttons.indexOf("restore") > -1
		},
		canReport: function () {
			return this.buttons.indexOf("report") > -1
		},
		canConfirm: function () {
			return this.buttons.indexOf("confirm") > -1
		}
	},
	methods: {
		handleFunc: function (destination, value) {
			this.$emit(destination, value, this.item)
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-menu";
</style>
